import { Flex } from '@chakra-ui/react';
import { ImportFilesPanel } from '../../../dialogs/ImportFilesPanel';
import type { CreateBodyProps } from './createBodyProps';

/**
 * Import files into the destination. Done means handed to the upload tray;
 * a parent that vanished in the meantime fails there (reserve's
 * INVALID_PARENT), not here.
 */
export function ImportBody({ destination, onDone }: CreateBodyProps) {
  return (
    <Flex direction="column" flex={1} minH={0}>
      <ImportFilesPanel
        parentEntityType={destination.type}
        parentEntityId={destination.id}
        trigger="create_modal"
        onDone={onDone}
      />
    </Flex>
  );
}
